import React, {createContext, ReactNode, useState} from 'react';

type LoginProps = {
    nome: string;
    email: string;
    logo: string;
    nomeEmpresa: string;
    setLogo: (p: string) => void;
    setNome: (p: string) => void;
    setEmail: (p: string) => void;
}

type ContextProviderProps = {
    children: ReactNode;
}
 
const initialState: LoginProps = {
    nome        : '',
    email       : '',
    logo        : '',        
    nomeEmpresa : '',        
    setLogo     : () => {},
    setNome     : () => {},
    setEmail    : () => {},
}

export const LoginContext = createContext<LoginProps>(initialState);

export const LoginContextProvider = ({children}: ContextProviderProps) => {

    const [logo, setLogo] = useState('');
    
    const AlterarLogo = (logo: string) => {        
        setLogo(logo);
    }

    initialState.setLogo = AlterarLogo;
    initialState.logo    = logo;

    return (
        <LoginContext.Provider value={initialState}>
            {children}
        </LoginContext.Provider>
    )
}

